import React from "react";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { Grid, InputAdornment, Link } from "@material-ui/core";
import { connect } from "react-redux";
import DecimalPositif from "../indicateurs/DecimalPositif";
import Network from "../../../../../actions/external/network";
import { downloadBlob } from "../../../../../scripts/utils";

const mapStateToProps = (state) => ({
  userRole: state.auth.role,
});

class SurfaceHortiPepi extends React.Component {
  handleChangeIndicateur = (newIndicateur) => {
    const { changeIndicateur, sousRubriqueIndex, libelleEnglobantIndex } = this.props;
    changeIndicateur(newIndicateur, sousRubriqueIndex, libelleEnglobantIndex);
  };
  render() {
    const { indicateurs, computedFields } = this.props;

    const prodCouvertesKeys = [
      "HVE4_CULT_D_48",
      "HVE4_CULT_D_49",
      "HVE4_CULT_D_50",
      "HVE4_CULT_D_51",
      "HVE4_CULT_D_52",
      "HVE4_CULT_D_53",
      "HVE4_CULT_D_54",
      "HVE4_CULT_D_55",
    ];
    const prodExtKeys = [
      "HVE4_CULT_D_56",
      "HVE4_CULT_D_57",
      "HVE4_CULT_D_58",
      "HVE4_CULT_D_59",
      "HVE4_CULT_D_60",
      "HVE4_CULT_D_61",
      "HVE4_CULT_D_62",
      "HVE4_CULT_D_63",
      "HVE4_CULT_D_64",
      "HVE4_CULT_D_65",
      "HVE4_CULT_D_66",
      "HVE4_CULT_D_67",
      "HVE4_CULT_D_68",
      "HVE4_CULT_D_69_NC_hors_sol",
      "HVE4_CULT_D_70_NC_totale",
    ];

    const totauxKeys = ["HVE4_CULT_D_69", "HVE4_CULT_D_70"];
    const prodCouvertesToDisplay = Object.values(
      Object.fromEntries(Object.entries(indicateurs).filter(([key]) => prodCouvertesKeys.includes(key)))
    );
    const prodExtToDisplay = Object.values(
      Object.fromEntries(Object.entries(indicateurs).filter(([key]) => prodExtKeys.includes(key)))
    );
    const totauxToDisplay = Object.values(
      Object.fromEntries(Object.entries(indicateurs).filter(([key]) => totauxKeys.includes(key)))
    );
    return (
      <React.Fragment>
        {prodCouvertesToDisplay.length > 0 && (
          <div>
            <Link
              onClick={async () => {
                const response = await Network.fetch(`/api/documents/calculette_horti_pepi.xlsx`);
                await downloadBlob(response);
              }}
            >
              Calculette SAU en horticulture et pépinière
            </Link>
          </div>
        )}
        <div>
          <div className={"d-flex align-items-center"}>
            <Grid item xs={4}>
              <h2>Productions couvertes</h2>
            </Grid>
            <Grid item xs={8} className={"d-flex"}>
              <div style={{ width: "4rem" }} />
              <div
                style={{
                  width: "10rem",
                  fontWeight: "bold",
                }}
              >
                N
              </div>
              <div
                style={{
                  width: "10rem",
                  fontWeight: "bold",
                }}
              >
                N-1
              </div>
              <div
                style={{
                  width: "10rem",
                  fontWeight: "bold",
                }}
              >
                N-2
              </div>
            </Grid>
          </div>
          {prodCouvertesToDisplay.map((indic) => (
            <div className={"d-flex align-items-center mb-1"} key={"indic-" + indic.idIndicateur}>
              <Grid item xs={4}>
                <div className={indic.afficherGras ? "mr-3 bold" : "mr-3"}>{indic.libelle}</div>
              </Grid>
              <Grid item>
                <DecimalPositif
                  fixedDecimalScale={true}
                  size={"small"}
                  indicateur={indic}
                  key={"indicateur-" + indic.idIndicateur}
                  changeIndicateur={this.handleChangeIndicateur}
                  valueInputProps={
                    indic.libelleUnite != null && {
                      endAdornment: <InputAdornment position={"end"}>{indic.libelleUnite}</InputAdornment>,
                    }
                  }
                  computedFields={computedFields}
                  showValueN_1N_2={true}
                />
              </Grid>
            </div>
          ))}
        </div>
        {prodExtToDisplay.length > 0 && (
          <div className={"d-flex align-items-center"}>
            <Grid item xs={4}>
              <h2>Productions extérieurs</h2>
            </Grid>
            <Grid item xs={8} className={"d-flex"}>
              <div style={{ width: "4rem" }} />
              <div
                style={{
                  width: "10rem",
                  fontWeight: "bold",
                }}
              >
                N
              </div>
              <div
                style={{
                  width: "10rem",
                  fontWeight: "bold",
                }}
              >
                N-1
              </div>
              <div
                style={{
                  width: "10rem",
                  fontWeight: "bold",
                }}
              >
                N-2
              </div>
            </Grid>
          </div>
        )}
        <div>
          {prodExtToDisplay.map((indic) => (
            <div className={"d-flex align-items-center mb-1"} key={"indic-" + indic.idIndicateur}>
              <Grid item xs={4}>
                <div className={indic.afficherGras ? "mr-3 bold" : "mr-3"}>{indic.libelle}</div>
              </Grid>
              <Grid item>
                <DecimalPositif
                  fixedDecimalScale={true}
                  size={"small"}
                  indicateur={indic}
                  key={"indicateur-" + indic.idIndicateur}
                  changeIndicateur={this.handleChangeIndicateur}
                  valueInputProps={
                    indic.libelleUnite != null && {
                      endAdornment: <InputAdornment position={"end"}>{indic.libelleUnite}</InputAdornment>,
                    }
                  }
                  computedFields={computedFields}
                  showValueN_1N_2={true}
                />
              </Grid>
            </div>
          ))}
        </div>
        <div>
          {totauxToDisplay.map((indic) => (
            <div className={"d-flex align-items-center mb-1"} key={"indic-" + indic.idIndicateur}>
              <Grid item xs={4}>
                <div className={indic.afficherGras ? "bold" : ""}>{indic.libelle}</div>
              </Grid>
              <Grid item>
                <DecimalPositif
                  fixedDecimalScale={true}
                  size={"small"}
                  indicateur={indic}
                  key={"indicateur-" + indic.idIndicateur}
                  changeIndicateur={this.handleChangeIndicateur}
                  valueInputProps={
                    indic.libelleUnite != null && {
                      endAdornment: <InputAdornment position={"end"}>{indic.libelleUnite}</InputAdornment>,
                    }
                  }
                  computedFields={computedFields}
                  showValueN_1N_2={true}
                />
              </Grid>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default compose(withTranslation(), connect(mapStateToProps))(SurfaceHortiPepi);
